import { DEPOSIT_CLEARED_FUNDS_NOTE } from './invoicePaymentTerms';
import { normalizeInvoiceRole } from './invoiceLedger';

function stripDivsWithClass(html: string, className: string): string {
  const openRe = new RegExp(
    `<div\\b[^>]*class="[^"]*\\b${className}\\b[^"]*"[^>]*>`,
    'gi',
  );
  let next = html;
  let match = openRe.exec(next);
  while (match) {
    const start = match.index;
    let depth = 1;
    let cursor = start + match[0].length;
    const lower = next.toLowerCase();
    while (cursor < next.length && depth > 0) {
      const nextOpen = lower.indexOf('<div', cursor);
      const nextClose = lower.indexOf('</div>', cursor);
      if (nextClose === -1) {
        cursor = next.length;
        break;
      }
      if (nextOpen !== -1 && nextOpen < nextClose) {
        depth += 1;
        cursor = nextOpen + 4;
      } else {
        depth -= 1;
        cursor = nextClose + 6;
      }
    }
    next = `${next.slice(0, start)}${next.slice(cursor)}`;
    openRe.lastIndex = start;
    match = openRe.exec(next);
  }
  return next;
}

/** Public-doc may still inject deposit payment terms, or leave an unreplaced mustache. */
export function sanitizePublicInvoicePdfHtml(html: string, invoiceRole?: string | null): string {
  let next = String(html || '');
  if (normalizeInvoiceRole(invoiceRole) === 'deposit') {
    next = stripDivsWithClass(next, 'invoice-payment-schedule');
    // Half-stripped leftovers from the old first-</div> regex, or template-header terms.
    next = next.replace(
      /<div[^>]*class="[^"]*\bdate\b[^"]*"[^>]*>\s*Payment terms:[\s\S]*?<\/div>/gi,
      '',
    );
    next = next.replace(
      /<div[^>]*class="[^"]*\bdate\b[^"]*"[^>]*>\s*Due date:[\s\S]*?<\/div>/gi,
      '',
    );
    next = next.replace(
      /<div[^>]*class="[^"]*\bpayment-terms\b[^"]*"[^>]*>[\s\S]*?<\/div>/gi,
      '',
    );
  }
  next = next.replace(/\{\{\s*depositClearedFundsNote\s*\}\}/g, DEPOSIT_CLEARED_FUNDS_NOTE);
  next = next.replace(
    /(^|[^A-Za-z0-9_])depositClearedFundsNote(?![A-Za-z0-9_])/g,
    `$1${DEPOSIT_CLEARED_FUNDS_NOTE}`,
  );
  return next;
}
